export default __webpack_public_path__ + "static/media/play.1fa504d1.svg";